import { render, staticRenderFns } from "./CreateUblArchiveModalForm.vue?vue&type=template&id=00eb762c&scoped=true"
import script from "./CreateUblArchiveModalForm.vue?vue&type=script&lang=ts"
export * from "./CreateUblArchiveModalForm.vue?vue&type=script&lang=ts"
import style0 from "./CreateUblArchiveModalForm.vue?vue&type=style&index=0&id=00eb762c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00eb762c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00eb762c')) {
      api.createRecord('00eb762c', component.options)
    } else {
      api.reload('00eb762c', component.options)
    }
    module.hot.accept("./CreateUblArchiveModalForm.vue?vue&type=template&id=00eb762c&scoped=true", function () {
      api.rerender('00eb762c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/CreateUblArchiveModalForm.vue"
export default component.exports